(function () {
  function selectedModelText(container) {
    if (container.dataset.rockcat === 'true') return 'rockcat';
    const productView = container.closest('.productView');
    if (!productView) return '';
    const checked = Array.from(productView.querySelectorAll('.product-form__radio:checked:not(.mobile)')).map((input) => input.value);
    const selected = Array.from(productView.querySelectorAll('.product-form__input--dropdown:not(.mobile) select')).map((select) => select.value);
    return checked.concat(selected).join(' ').toLowerCase();
  }

  function bagSizeFor(container) {
    const model = selectedModelText(container);
    if (model.includes('rockcat')) return '85';
    if (/\b(270|300|330)\b/.test(model)) return '85';
    if (/\b(360|390|430)\b/.test(model)) return '95';
    return container.dataset.defaultBagSize || '';
  }

  function selectedBoatPrice(container) {
    const productView = container.closest('.productView');
    const priceData = container.querySelector('[data-rb-variant-prices]');
    const variantInput = productView && productView.querySelector('product-form form [name="id"]');
    if (!priceData || !variantInput) return 0;

    try {
      const prices = JSON.parse('{' + priceData.textContent.trim() + '}');
      return Number(prices[variantInput.value] || 0);
    } catch (error) {
      return 0;
    }
  }

  function updateAddonTotal(container, bagSize) {
    const totalRow = container.querySelector('[data-addon-total]');
    const totalPrice = container.querySelector('[data-addon-total-price]');
    const selectedAddon = container.querySelector('.rb-addon-checkbox:checked');
    if (!totalRow || !totalPrice || !selectedAddon || !bagSize) {
      if (totalRow) totalRow.hidden = true;
      return;
    }

    const addonPrice = Number(selectedAddon.getAttribute('data-price-cents-' + bagSize) || 0);
    const combinedPrice = selectedBoatPrice(container) + addonPrice;
    totalPrice.textContent = Shopify.formatMoney(combinedPrice, window.money_format);
    totalRow.hidden = false;
  }

  function updateAddonState(container) {
    const bagSize = bagSizeFor(container);
    container.hidden = !bagSize;
    container.querySelectorAll('.rb-addon-checkbox').forEach((input) => {
      input.value = bagSize ? (input.getAttribute('data-variant-' + bagSize) || '') : '';
      input.disabled = !input.value;
      const row = input.closest('.rb-addon');
      row.querySelectorAll('[data-addon-bag-size]').forEach((node) => { node.textContent = bagSize; });
      const price = row.querySelector('[data-addon-price]');
      if (price) price.textContent = input.getAttribute('data-price-' + bagSize) || '';
      if (input.disabled) input.checked = false;
    });
    updateAddonTotal(container, bagSize);
  }

  function init() {
    document.querySelectorAll('[data-rockboat-addons]').forEach((container) => updateAddonState(container));
  }

  document.addEventListener('change', (event) => {
    if (event.target.classList.contains('rb-addon-checkbox')) {
      if (event.target.checked) {
        document.querySelectorAll('[data-rockboat-addons] .rb-addon-checkbox').forEach((input) => {
          if (input !== event.target) input.checked = false;
        });
      }
      const container = event.target.closest('[data-rockboat-addons]');
      updateAddonTotal(container, bagSizeFor(container));
      return;
    }
    if (event.target.closest('.productView')) {
      window.setTimeout(init, 80);
    }
  }, true);

  document.addEventListener('click', (event) => {
    if (event.target.closest('.rb-addon__details')) {
      event.stopPropagation();
      return;
    }

    if (event.target.closest('.product-form__label')) {
      window.setTimeout(init, 80);
    }
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
